import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDataImportDateFormat implements BaseEnumType {
  private static allValues: EnumDataImportDateFormat[] = []; // make sure this is top-most
  
  public static yyyyMmDd = new EnumDataImportDateFormat(0, "YyyyMmDd", "enum_data_import_date_format_yyyy_mm_dd");
  public static ddMmYyyy = new EnumDataImportDateFormat(1, "DdMmYyyy", "enum_data_import_date_format_dd_mm_yyyy");
  public static ddMmYy = new EnumDataImportDateFormat(2, "DdMmYy", "enum_data_import_date_format_dd_mm_yy");
  public static mmDdYyyy = new EnumDataImportDateFormat(3, "MmDdYyyy", "enum_data_import_date_format_mm_dd_yyyy");
  public static mmDdYy = new EnumDataImportDateFormat(4, "MmDdYy", "enum_data_import_date_format_mm_dd_yy");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDataImportDateFormat.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isYyyyMmDd() { return this === EnumDataImportDateFormat.yyyyMmDd; }
  public isDdMmYyyy() { return this === EnumDataImportDateFormat.ddMmYyyy; }
  public isDdMmYy() { return this === EnumDataImportDateFormat.ddMmYy; }
  public isMmDdYyyy() { return this === EnumDataImportDateFormat.mmDdYyyy; }
  public isMmDdYy() { return this === EnumDataImportDateFormat.mmDdYy; }

  public static getValues(): readonly EnumDataImportDateFormat[] {
    return EnumDataImportDateFormat.allValues;
  }

  public static getValuesExcept0(): readonly EnumDataImportDateFormat[] {
    return EnumDataImportDateFormat.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDataImportDateFormat {
    const found = EnumDataImportDateFormat.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDataImportDateFormat - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDataImportDateFormat): EnumDataImportDateFormat {
    const found = name ? EnumDataImportDateFormat.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDataImportDateFormat - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDataImportDateFormat>): boolean {
    return this.key === other?.key;
  }
}